import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=39d5c1ea&scoped=true&"
import script from "./HomeInfo.vue?vue&type=script&lang=js&"
export * from "./HomeInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=39d5c1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5c1ea",
  null
  
)

export default component.exports